// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Group overview (/overview) — multi-business stats page.
   Standalone page: renders without the app header or side nav. */

.overview-page {
  --ov-ink: #191714;
  --ov-canvas: #f6f4ef;
  --ov-card: #ffffff;
  --ov-line: #e7e3da;
  --ov-line-soft: #f0ece3;
  --ov-muted: #8b8477;
  --ov-muted-2: #a29b8d;
  --ov-body: #4a453c;
  --ov-gold: var(--rf-brand);
  --ov-gold-lite: var(--rf-brand-lite);
  --ov-gold-bright: var(--rf-brand-bright);
  --ov-teal: var(--rf-accent);
  --ov-up: #4d7a52;
  --ov-down: #a8483e;
  --ov-warn: #b0872f;

  width: 100%;
  min-height: 100vh;
  background: var(--ov-canvas);
  color: var(--ov-ink);
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}
.overview-page *,
.overview-page *::before,
.overview-page *::after {
  box-sizing: border-box;
  /* App.css sets \`* { transition: 300ms }\`; this design has no animations. */
  transition: none;
}
.overview-page .ov-serif {
  font-family: "Instrument Serif", Georgia, serif;
  font-weight: 400;
}
.overview-page .ov-num {
  font-variant-numeric: tabular-nums;
}
.overview-page .ov-nowrap {
  white-space: nowrap;
}

/* ---------- top bar ---------- */
.ov-topbar {
  height: 68px;
  background: var(--ov-card);
  border-bottom: 1px solid var(--ov-line);
  padding: 0 28px;
  display: flex;
  align-items: center;
  gap: 18px;
}
.ov-topbar-brand {
  display: flex;
  align-items: center;
  gap: 11px;
}
.ov-rule-v {
  width: 1px;
  height: 26px;
  background: var(--ov-line);
  display: block;
}
.ov-topbar-title {
  font-size: 22px;
  line-height: 1;
  white-space: nowrap;
}
.ov-spacer {
  flex-grow: 1;
}
.ov-user-wrap {
  position: relative;
}
.ov-user {
  display: flex;
  align-items: center;
  gap: 9px;
  height: 36px;
  margin: 0 -8px;
  padding: 0 8px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: inherit;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
}
.ov-user:hover,
.ov-user.is-open {
  background: var(--ov-canvas);
}
.ov-user .ov-caret {
  font-size: 10px;
  color: var(--ov-muted-2);
  margin-left: 2px;
}
.ov-user img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.ov-user-name {
  font-size: 12.5px;
  font-weight: 600;
  white-space: nowrap;
}
.ov-user-role {
  font-size: 11px;
  color: var(--ov-muted);
  white-space: nowrap;
}

/* ---------- profile menu ---------- */
.ov-profile-menu {
  position: absolute;
  right: -8px;
  top: 44px;
  z-index: 30;
  width: 264px;
  background: #fff;
  border: 1px solid #ddd7cb;
  border-radius: 12px;
  box-shadow: 0 16px 44px rgba(40, 34, 22, 0.16);
  padding: 16px 18px 14px;
}
.ov-profile-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--ov-line-soft);
}
.ov-profile-card img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.ov-profile-text {
  min-width: 0;
}
.ov-profile-name {
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 18px;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ov-profile-role {
  font-size: 12px;
  color: var(--ov-muted);
  margin-top: 3px;
  white-space: nowrap;
}
.ov-profile-user {
  font-size: 11.5px;
  color: var(--ov-muted-2);
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ov-profile-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 0;
}
.ov-profile-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  font-size: 12.5px;
  color: var(--ov-body);
}
.ov-profile-row > span:last-child {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ov-profile-foot {
  padding-top: 12px;
  border-top: 1px solid var(--ov-line-soft);
}
.ov-btn-logout {
  width: 100%;
  color: var(--ov-down);
}
.ov-btn-logout:hover {
  background: #fbefed;
  border-color: #e9cfcb;
}

/* ---------- date picker ---------- */
.ov-datepicker {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}
.ov-segmented {
  display: flex;
  gap: 2px;
  background: #eae6dd;
  padding: 3px;
  border-radius: 9px;
}
.ov-segmented button {
  border: none;
  cursor: pointer;
  padding: 6px 13px;
  border-radius: 7px;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  background: transparent;
  color: #7c766a;
  white-space: nowrap;
}
.ov-segmented button.is-active {
  background: #fff;
  color: var(--ov-ink);
  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.14);
}
.ov-range-btn {
  height: 36px;
  font-family: inherit;
  color: inherit;
  border: 1px solid var(--ov-line);
  border-radius: 9px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 13px;
  cursor: pointer;
}
.ov-range-btn:hover,
.ov-range-btn.is-open {
  border-color: var(--ov-gold-lite);
}
.ov-range-btn .ov-range-label {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.ov-range-btn .ov-range-days {
  font-size: 11.5px;
  color: var(--ov-muted-2);
  white-space: nowrap;
}
.ov-range-btn .ov-caret {
  font-size: 10px;
  color: var(--ov-muted-2);
}

.ov-cal {
  position: absolute;
  right: 0;
  top: 44px;
  z-index: 30;
  width: 512px;
  background: #fff;
  border: 1px solid #ddd7cb;
  border-radius: 12px;
  box-shadow: 0 16px 44px rgba(40, 34, 22, 0.16);
  padding: 16px 18px;
}
.ov-cal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 13.5px;
  font-weight: 600;
}
.ov-cal-close {
  background: none;
  border: none;
  padding: 0;
  font-size: 16px;
  line-height: 1;
  color: #bdb6a7;
  cursor: pointer;
}
.ov-cal-inputs {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}
.ov-field {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.ov-label {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ov-muted);
  white-space: nowrap;
}
.ov-field input {
  height: 38px;
  border: 1px solid var(--ov-line);
  border-radius: 8px;
  background: #fdfcfa;
  padding: 0 12px;
  font: 400 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--ov-ink);
  outline: none;
  font-variant-numeric: tabular-nums;
}
.ov-field input:focus {
  border-color: var(--ov-gold-lite);
  background: #fff;
}
.ov-cal-months {
  display: flex;
  gap: 16px;
}
/* month-grid styles moved to components/CalendarMonth/style.css */
.ov-cal-foot {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--ov-line-soft);
}
.ov-cal-foot span {
  font-size: 11.5px;
  color: var(--ov-muted-2);
  flex-grow: 1;
}

.ov-btn {
  cursor: pointer;
  height: 34px;
  padding: 0 15px;
  border-radius: 8px;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
}
.ov-btn-ghost {
  border: 1px solid var(--ov-line);
  background: #fff;
  color: var(--ov-body);
}
.ov-btn-ghost:hover {
  background: var(--ov-canvas);
}
.ov-btn-primary {
  border: none;
  background: var(--ov-gold);
  color: #fff;
}
.ov-btn-primary:hover {
  background: var(--rf-brand-hover);
}
.ov-btn-primary:disabled {
  opacity: 0.5;
  cursor: default;
}
.ov-btn-primary:disabled:hover {
  background: var(--ov-gold);
}

/* ---------- body / section headers ---------- */
.ov-body {
  width: 80%;
  margin: 0 auto;
  padding: 22px 28px 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ov-section-head {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 10px;
}
.ov-eyebrow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ov-muted);
  white-space: nowrap;
}
.ov-section-rule {
  flex-grow: 1;
  height: 1px;
  background: #ddd7cb;
}
.ov-section-meta {
  font-size: 12px;
  color: var(--ov-muted);
  white-space: nowrap;
}

/* ---------- section 1: group total ---------- */
.ov-group {
  background: var(--ov-ink);
  border-radius: 14px;
  padding: 22px 24px;
  display: flex;
  gap: 26px;
  color: #fff;
}
.ov-group-left {
  width: 334px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
.ov-group-eyebrow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a8272;
  margin-bottom: 8px;
}
.ov-group-total {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}
.ov-group-total .ov-figure {
  font-size: 54px;
  line-height: 0.92;
  color: var(--ov-gold-bright);
}
.ov-delta-chip {
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 20px;
  margin-bottom: 8px;
  white-space: nowrap;
  color: #8fbf9b;
  background: #22301f;
}
.ov-group-sub {
  font-size: 12.5px;
  color: var(--ov-muted-2);
  margin-top: 8px;
}
.ov-split {
  margin-top: auto;
  padding-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 9px;
}
.ov-split-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 5px;
}
.ov-split-name {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
  color: #e6e1d6;
  white-space: nowrap;
}
.ov-swatch {
  width: 9px;
  height: 9px;
  border-radius: 2px;
  display: block;
  flex-shrink: 0;
}
.ov-split-value {
  font-size: 12.5px;
  font-weight: 600;
  white-space: nowrap;
}
.ov-track-dark {
  height: 7px;
  background: #302b23;
  border-radius: 20px;
  overflow: hidden;
}
.ov-track-dark > span {
  display: block;
  height: 100%;
  border-radius: 20px;
}
.ov-group-divider {
  width: 1px;
  background: #302b23;
  flex-shrink: 0;
}
.ov-group-right {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.ov-kpi-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-bottom: 18px;
}
.ov-kpi {
  padding: 0 18px;
  border-left: 1px solid #302b23;
}
.ov-kpi:first-child {
  border-left-color: transparent;
}
.ov-kpi-label {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a8272;
  white-space: nowrap;
  margin-bottom: 6px;
}
.ov-kpi-value {
  display: flex;
  align-items: baseline;
  gap: 7px;
}
.ov-kpi-value .ov-figure {
  font-size: 30px;
  line-height: 1;
}
.ov-kpi-delta {
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;
}
.ov-kpi-sub {
  font-size: 11.5px;
  color: #8a8272;
  margin-top: 4px;
  white-space: nowrap;
}
.ov-chart-head {
  display: flex;
  align-items: baseline;
  gap: 14px;
  margin-bottom: 8px;
  font-size: 12.5px;
  font-weight: 600;
}
.ov-legend {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 400;
  color: var(--ov-muted-2);
  white-space: nowrap;
}
.ov-legend i {
  width: 14px;
  height: 2px;
  display: block;
}
.ov-chart {
  height: 132px;
}
.ov-chart svg {
  width: 100%;
  height: 100%;
  display: block;
  overflow: visible;
}
.ov-chart-axis {
  display: flex;
  justify-content: space-between;
  padding-top: 7px;
  border-top: 1px solid #2b261e;
  margin-top: 7px;
}
.ov-chart-axis span {
  font-size: 10.5px;
  color: #8a8272;
  white-space: nowrap;
}

/* ---------- sections 2 & 3: per business ---------- */
.ov-businesses {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.ov-biz {
  background: var(--ov-card);
  border: 1px solid var(--ov-line);
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.ov-biz-head {
  padding: 16px 20px;
  border-bottom: 1px solid var(--ov-line-soft);
  display: flex;
  align-items: center;
  gap: 12px;
}
.ov-biz-accent {
  width: 4px;
  height: 38px;
  border-radius: 2px;
  flex-shrink: 0;
}
.ov-biz-logo {
  height: 40px;
  width: auto;
  max-width: 110px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}

/* Stands in for the logo for a business with no artwork — same footprint
   as .ov-biz-logo so the card header keeps its rhythm. The colour is the
   business's assigned accent, set inline. */
.ov-biz-mark {
  height: 40px;
  min-width: 40px;
  padding: 0 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid currentColor;
  border-radius: 7px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.04em;
}
.ov-biz-title {
  flex-grow: 1;
  min-width: 0;
}
.ov-biz-name {
  font-size: 21px;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ov-biz-meta {
  font-size: 12px;
  color: var(--ov-muted);
  margin-top: 2px;
  white-space: nowrap;
}
.ov-chip {
  font-size: 11.5px;
  font-weight: 600;
  padding: 4px 9px;
  border-radius: 20px;
  white-space: nowrap;
}
.ov-chip-ok {
  color: var(--ov-up);
  background: #eaf1e9;
}
.ov-chip-warn {
  color: var(--ov-warn);
  background: #f9f1de;
}
.ov-link {
  background: none;
  border: none;
  padding: 0;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--ov-gold);
  cursor: pointer;
  white-space: nowrap;
}
.ov-biz-body {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.ov-biz-kpis {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.ov-biz-kpi {
  padding: 0 12px;
  border-left: 1px solid var(--ov-line);
}
.ov-biz-kpi:first-child {
  border-left-color: transparent;
}
.ov-biz-kpi .ov-kpi-label {
  color: var(--ov-muted);
  font-size: 10px;
  letter-spacing: 0.07em;
  margin-bottom: 5px;
}
.ov-biz-kpi .ov-figure {
  font-size: 25px;
  line-height: 1;
  color: var(--ov-ink);
}
.ov-biz-kpi .ov-kpi-delta {
  font-size: 11px;
}
.ov-up {
  color: var(--ov-up);
}
.ov-down {
  color: var(--ov-down);
}

.ov-panel {
  background: #fbf9f5;
  border: 1px solid #eee9df;
  border-radius: 10px;
  padding: 12px 14px;
}
.ov-panel-head,
.ov-block-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 9px;
}
.ov-panel-head b,
.ov-block-head b {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.ov-panel-head span,
.ov-block-head span {
  font-size: 11.5px;
  color: var(--ov-muted);
  white-space: nowrap;
}
.ov-stack {
  display: flex;
  gap: 3px;
  margin-bottom: 8px;
}
.ov-stack > i {
  height: 8px;
  border-radius: 3px;
  display: block;
}
.ov-stack-legend {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}
.ov-stack-legend span {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  color: #6f6a60;
  white-space: nowrap;
}
.ov-stack-legend b {
  font-weight: 600;
  color: var(--ov-ink);
  font-variant-numeric: tabular-nums;
}
.ov-swatch-sm {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  display: block;
  flex-shrink: 0;
}

.ov-sellers {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ov-donut {
  width: 74px;
  height: 74px;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ov-donut-hole {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #fff;
}
.ov-seller-list {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.ov-seller {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ov-seller-name {
  font-size: 12px;
  color: var(--ov-body);
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ov-seller-share {
  font-size: 11px;
  color: var(--ov-muted-2);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ov-seller-value {
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  width: 52px;
  text-align: right;
  white-space: nowrap;
}

.ov-money {
  display: flex;
  gap: 8px;
  padding-top: 13px;
  border-top: 1px solid var(--ov-line-soft);
}
.ov-money-cell {
  flex-grow: 1;
  border-radius: 9px;
  padding: 9px 12px;
  background: var(--ov-canvas);
}
.ov-money-cell.is-accent {
  background: var(--rf-brand-tint);
}
.ov-money-cell.is-accent-teal {
  background: var(--rf-accent-tint);
}
.ov-money-label {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--ov-muted);
  white-space: nowrap;
  margin-bottom: 4px;
}
.ov-money-value {
  font-size: 16px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ov-money-value.is-soft {
  color: #6f6a60;
}

/* ---------- section 4: staff & products ---------- */
/* Deliberately not a 1:1 grid: the business cards above are one column
   per business, and two equal cards here would read as belonging to them.
   Staff carries the level × business matrix, so it takes the wide column;
   Products sits narrower beside it. */
.ov-dir {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}
.ov-dir-card {
  background: var(--ov-card);
  border: 1px solid var(--ov-line);
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.ov-dir-head {
  padding: 16px 20px;
  border-bottom: 1px solid var(--ov-line-soft);
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
}
.ov-dir-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}
.ov-dir-figures {
  display: flex;
  align-items: flex-end;
  gap: 28px;
}
.ov-dir-head .ov-kpi-label {
  color: var(--ov-muted);
  font-size: 10px;
  letter-spacing: 0.07em;
  margin-bottom: 5px;
}
.ov-dir-head .ov-figure {
  font-size: 34px;
  line-height: 1;
  color: var(--ov-ink);
}
.ov-dir-head .ov-kpi-sub {
  color: var(--ov-muted);
  margin-top: 0;
}
.ov-dir-body {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* level × business matrix */
.ov-matrix {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}
.ov-matrix th {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--ov-muted);
  text-align: right;
  padding: 0 0 7px 10px;
  border-bottom: 1px solid var(--ov-line);
  white-space: nowrap;
}
.ov-matrix td {
  padding: 8px 0 8px 10px;
  border-bottom: 1px solid var(--ov-line-soft);
  text-align: right;
  color: var(--ov-body);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ov-matrix th:first-child,
.ov-matrix td:first-child {
  text-align: left;
  padding-left: 0;
}
.ov-matrix td:first-child {
  color: var(--ov-ink);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ov-matrix-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.ov-matrix td.is-zero {
  color: var(--ov-muted-2);
}
.ov-matrix td.is-total,
.ov-matrix tfoot td {
  font-weight: 600;
  color: var(--ov-ink);
}
.ov-matrix tfoot td {
  border-bottom: none;
  padding-top: 9px;
  padding-bottom: 0;
}

/* products per business */
.ov-dir-rows {
  display: flex;
  flex-direction: column;
  gap: 13px;
}
.ov-dir .ov-split-name,
.ov-dir .ov-split-value {
  color: var(--ov-ink);
}
.ov-track {
  height: 7px;
  background: var(--ov-line-soft);
  border-radius: 20px;
  overflow: hidden;
}
.ov-track > span {
  display: block;
  height: 100%;
  border-radius: 20px;
}
.ov-dir-sub {
  font-size: 11.5px;
  color: var(--ov-muted);
  margin-top: 5px;
  font-variant-numeric: tabular-nums;
}

/* ---------- loading skeleton / glare ---------- */
/* While \`.is-loading\` is on the page root, every \`.ov-skel\` block hides its
   content and shows a tinted placeholder with a sweeping glare; the three
   section cards get a softer full-card sweep on top. */
.ov-group,
.ov-biz,
.ov-dir-card {
  position: relative;
}
.is-loading .ov-group,
.is-loading .ov-biz {
  overflow: hidden;
}
.is-loading .ov-skel {
  position: relative;
  --skel-inset: 0;
  --skel-tint: #f1eee7;
  --skel-glare: rgba(255, 255, 255, 0.75);
}
.is-loading .ov-group .ov-skel {
  --skel-tint: #26221c;
  --skel-glare: rgba(255, 255, 255, 0.09);
}
.is-loading .ov-skel > * {
  visibility: hidden;
}
.is-loading .ov-skel::before,
.is-loading .ov-skel::after {
  content: "";
  position: absolute;
  inset: var(--skel-inset);
  border-radius: 10px;
  pointer-events: none;
}
.is-loading .ov-skel::before {
  background: var(--skel-tint);
}
.is-loading .ov-skel::after {
  overflow: hidden;
  background: linear-gradient(
    100deg,
    transparent 35%,
    var(--skel-glare) 50%,
    transparent 65%
  );
  background-size: 250% 100%;
  animation: ov-glare 1.5s ease-in-out infinite;
}
/* full-card sweep over each section card */
.is-loading .ov-group::after,
.is-loading .ov-biz::after,
.ov-dir-card.is-loading::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(
    100deg,
    transparent 40%,
    rgba(255, 255, 255, 0.5) 50%,
    transparent 60%
  );
  background-size: 300% 100%;
  animation: ov-glare 2.2s ease-in-out infinite;
  animation-delay: 0.3s;
}
.is-loading .ov-group::after {
  background-image: linear-gradient(
    100deg,
    transparent 40%,
    rgba(255, 255, 255, 0.06) 50%,
    transparent 60%
  );
}
@keyframes ov-glare {
  from {
    background-position: 100% 0;
  }
  to {
    background-position: -100% 0;
  }
}
/* skeleton tweaks for specific blocks */
.is-loading .ov-kpi,
.is-loading .ov-biz-kpi {
  --skel-inset: 0 8px;
  border-left-color: transparent;
}
.is-loading .ov-kpi {
  min-height: 64px;
}
.is-loading .ov-biz-kpi {
  min-height: 52px;
}
.is-loading .ov-chip {
  min-width: 84px;
  min-height: 24px;
  --skel-inset: 0;
}
.is-loading .ov-chip::before,
.is-loading .ov-chip::after {
  border-radius: 20px;
}
.is-loading .ov-group-hero {
  min-height: 120px;
}
.is-loading .ov-split::before,
.is-loading .ov-split::after {
  inset: 18px 0 0 0;
}
.is-loading .ov-chart-block {
  min-height: 190px;
}
.is-loading .ov-money-cell::before,
.is-loading .ov-money-cell::after {
  border-radius: 9px;
}
.is-loading .ov-sellers-block {
  min-height: 100px;
}
/* People & catalogue cards — each carries its own .is-loading */
.ov-dir-card.is-loading .ov-kpi-value {
  min-height: 34px;
  min-width: 96px;
}
.ov-dir-card.is-loading .ov-dir-skel-bar::before,
.ov-dir-card.is-loading .ov-dir-skel-bar::after {
  border-radius: 6px;
}
.ov-dir-card.is-loading .ov-dir-skel-bar {
  min-height: 10px;
}
.ov-dir-card.is-loading .ov-stack-legend::before,
.ov-dir-card.is-loading .ov-stack-legend::after,
.ov-dir-card.is-loading .ov-dir-row::before,
.ov-dir-card.is-loading .ov-dir-row::after {
  border-radius: 8px;
}
@media (prefers-reduced-motion: reduce) {
  .is-loading .ov-skel::after,
  .is-loading .ov-group::after,
  .is-loading .ov-biz::after,
  .ov-dir-card.is-loading::after {
    animation: none;
  }
}

/* ---------- responsive: tablet ---------- */
@media (max-width: 1200px) {
  .ov-businesses,
  .ov-dir {
    grid-template-columns: 1fr;
  }
  .ov-group {
    flex-wrap: wrap;
  }
  .ov-group-left {
    width: 100%;
  }
  .ov-group-divider {
    display: none;
  }
  .ov-cal {
    width: 380px;
  }
  .ov-cal-months {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/overview.css"],"names":[],"mappings":"AAAA;iEACiE;;AAEjE;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;;EAElB,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;EACpB,4DAA4D;EAC5D,mCAAmC;AACrC;AACA;;;EAGE,sBAAsB;EACtB,2EAA2E;EAC3E,gBAAgB;AAClB;AACA;EACE,+CAA+C;EAC/C,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,0BAA0B;EAC1B,uCAAuC;EACvC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gEAAgE;EAChE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gEAAgE;EAChE,oBAAoB;EACpB,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gEAAgE;AAClE;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;;AAEA,iDAAiD;AACjD;EACE,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,WAAW;AACb;AACA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;;4CAE4C;AAC5C;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,8DAA8D;EAC9D,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,qCAAqC;AACvC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA,sDAAsD;AACtD;;;sCAGsC;AACtC;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;AACpC;;AAEA,mDAAmD;AACnD;;uDAEuD;AACvD;;;EAGE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB;;;;;GAKC;EACD,0BAA0B;EAC1B,6CAA6C;AAC/C;AACA,2CAA2C;AAC3C;;;EAGE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB;;;;;GAKC;EACD,0BAA0B;EAC1B,6CAA6C;EAC7C,qBAAqB;AACvB;AACA;EACE;;;;;GAKC;AACH;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA,wCAAwC;AACxC;;EAEE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;EACE;;;;IAIE,eAAe;EACjB;AACF;;AAEA,6CAA6C;AAC7C;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Group overview (/overview) — multi-business stats page.\n   Standalone page: renders without the app header or side nav. */\n\n.overview-page {\n  --ov-ink: #191714;\n  --ov-canvas: #f6f4ef;\n  --ov-card: #ffffff;\n  --ov-line: #e7e3da;\n  --ov-line-soft: #f0ece3;\n  --ov-muted: #8b8477;\n  --ov-muted-2: #a29b8d;\n  --ov-body: #4a453c;\n  --ov-gold: var(--rf-brand);\n  --ov-gold-lite: var(--rf-brand-lite);\n  --ov-gold-bright: var(--rf-brand-bright);\n  --ov-teal: var(--rf-accent);\n  --ov-up: #4d7a52;\n  --ov-down: #a8483e;\n  --ov-warn: #b0872f;\n\n  width: 100%;\n  min-height: 100vh;\n  background: var(--ov-canvas);\n  color: var(--ov-ink);\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n}\n.overview-page *,\n.overview-page *::before,\n.overview-page *::after {\n  box-sizing: border-box;\n  /* App.css sets `* { transition: 300ms }`; this design has no animations. */\n  transition: none;\n}\n.overview-page .ov-serif {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-weight: 400;\n}\n.overview-page .ov-num {\n  font-variant-numeric: tabular-nums;\n}\n.overview-page .ov-nowrap {\n  white-space: nowrap;\n}\n\n/* ---------- top bar ---------- */\n.ov-topbar {\n  height: 68px;\n  background: var(--ov-card);\n  border-bottom: 1px solid var(--ov-line);\n  padding: 0 28px;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n}\n.ov-topbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n}\n.ov-rule-v {\n  width: 1px;\n  height: 26px;\n  background: var(--ov-line);\n  display: block;\n}\n.ov-topbar-title {\n  font-size: 22px;\n  line-height: 1;\n  white-space: nowrap;\n}\n.ov-spacer {\n  flex-grow: 1;\n}\n.ov-user-wrap {\n  position: relative;\n}\n.ov-user {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  height: 36px;\n  margin: 0 -8px;\n  padding: 0 8px;\n  border: none;\n  border-radius: 9px;\n  background: transparent;\n  color: inherit;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n.ov-user:hover,\n.ov-user.is-open {\n  background: var(--ov-canvas);\n}\n.ov-user .ov-caret {\n  font-size: 10px;\n  color: var(--ov-muted-2);\n  margin-left: 2px;\n}\n.ov-user img {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.ov-user-name {\n  font-size: 12.5px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.ov-user-role {\n  font-size: 11px;\n  color: var(--ov-muted);\n  white-space: nowrap;\n}\n\n/* ---------- profile menu ---------- */\n.ov-profile-menu {\n  position: absolute;\n  right: -8px;\n  top: 44px;\n  z-index: 30;\n  width: 264px;\n  background: #fff;\n  border: 1px solid #ddd7cb;\n  border-radius: 12px;\n  box-shadow: 0 16px 44px rgba(40, 34, 22, 0.16);\n  padding: 16px 18px 14px;\n}\n.ov-profile-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--ov-line-soft);\n}\n.ov-profile-card img {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n.ov-profile-text {\n  min-width: 0;\n}\n.ov-profile-name {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 18px;\n  line-height: 1.1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ov-profile-role {\n  font-size: 12px;\n  color: var(--ov-muted);\n  margin-top: 3px;\n  white-space: nowrap;\n}\n.ov-profile-user {\n  font-size: 11.5px;\n  color: var(--ov-muted-2);\n  margin-top: 1px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ov-profile-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 0;\n}\n.ov-profile-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 12.5px;\n  color: var(--ov-body);\n}\n.ov-profile-row > span:last-child {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ov-profile-foot {\n  padding-top: 12px;\n  border-top: 1px solid var(--ov-line-soft);\n}\n.ov-btn-logout {\n  width: 100%;\n  color: var(--ov-down);\n}\n.ov-btn-logout:hover {\n  background: #fbefed;\n  border-color: #e9cfcb;\n}\n\n/* ---------- date picker ---------- */\n.ov-datepicker {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n}\n.ov-segmented {\n  display: flex;\n  gap: 2px;\n  background: #eae6dd;\n  padding: 3px;\n  border-radius: 9px;\n}\n.ov-segmented button {\n  border: none;\n  cursor: pointer;\n  padding: 6px 13px;\n  border-radius: 7px;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  background: transparent;\n  color: #7c766a;\n  white-space: nowrap;\n}\n.ov-segmented button.is-active {\n  background: #fff;\n  color: var(--ov-ink);\n  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.14);\n}\n.ov-range-btn {\n  height: 36px;\n  font-family: inherit;\n  color: inherit;\n  border: 1px solid var(--ov-line);\n  border-radius: 9px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 13px;\n  cursor: pointer;\n}\n.ov-range-btn:hover,\n.ov-range-btn.is-open {\n  border-color: var(--ov-gold-lite);\n}\n.ov-range-btn .ov-range-label {\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.ov-range-btn .ov-range-days {\n  font-size: 11.5px;\n  color: var(--ov-muted-2);\n  white-space: nowrap;\n}\n.ov-range-btn .ov-caret {\n  font-size: 10px;\n  color: var(--ov-muted-2);\n}\n\n.ov-cal {\n  position: absolute;\n  right: 0;\n  top: 44px;\n  z-index: 30;\n  width: 512px;\n  background: #fff;\n  border: 1px solid #ddd7cb;\n  border-radius: 12px;\n  box-shadow: 0 16px 44px rgba(40, 34, 22, 0.16);\n  padding: 16px 18px;\n}\n.ov-cal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  font-size: 13.5px;\n  font-weight: 600;\n}\n.ov-cal-close {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 16px;\n  line-height: 1;\n  color: #bdb6a7;\n  cursor: pointer;\n}\n.ov-cal-inputs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n.ov-field {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.ov-label {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--ov-muted);\n  white-space: nowrap;\n}\n.ov-field input {\n  height: 38px;\n  border: 1px solid var(--ov-line);\n  border-radius: 8px;\n  background: #fdfcfa;\n  padding: 0 12px;\n  font: 400 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--ov-ink);\n  outline: none;\n  font-variant-numeric: tabular-nums;\n}\n.ov-field input:focus {\n  border-color: var(--ov-gold-lite);\n  background: #fff;\n}\n.ov-cal-months {\n  display: flex;\n  gap: 16px;\n}\n/* month-grid styles moved to components/CalendarMonth/style.css */\n.ov-cal-foot {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid var(--ov-line-soft);\n}\n.ov-cal-foot span {\n  font-size: 11.5px;\n  color: var(--ov-muted-2);\n  flex-grow: 1;\n}\n\n.ov-btn {\n  cursor: pointer;\n  height: 34px;\n  padding: 0 15px;\n  border-radius: 8px;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n}\n.ov-btn-ghost {\n  border: 1px solid var(--ov-line);\n  background: #fff;\n  color: var(--ov-body);\n}\n.ov-btn-ghost:hover {\n  background: var(--ov-canvas);\n}\n.ov-btn-primary {\n  border: none;\n  background: var(--ov-gold);\n  color: #fff;\n}\n.ov-btn-primary:hover {\n  background: var(--rf-brand-hover);\n}\n.ov-btn-primary:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.ov-btn-primary:disabled:hover {\n  background: var(--ov-gold);\n}\n\n/* ---------- body / section headers ---------- */\n.ov-body {\n  width: 80%;\n  margin: 0 auto;\n  padding: 22px 28px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.ov-section-head {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n.ov-eyebrow {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ov-muted);\n  white-space: nowrap;\n}\n.ov-section-rule {\n  flex-grow: 1;\n  height: 1px;\n  background: #ddd7cb;\n}\n.ov-section-meta {\n  font-size: 12px;\n  color: var(--ov-muted);\n  white-space: nowrap;\n}\n\n/* ---------- section 1: group total ---------- */\n.ov-group {\n  background: var(--ov-ink);\n  border-radius: 14px;\n  padding: 22px 24px;\n  display: flex;\n  gap: 26px;\n  color: #fff;\n}\n.ov-group-left {\n  width: 334px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n}\n.ov-group-eyebrow {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #8a8272;\n  margin-bottom: 8px;\n}\n.ov-group-total {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n}\n.ov-group-total .ov-figure {\n  font-size: 54px;\n  line-height: 0.92;\n  color: var(--ov-gold-bright);\n}\n.ov-delta-chip {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 20px;\n  margin-bottom: 8px;\n  white-space: nowrap;\n  color: #8fbf9b;\n  background: #22301f;\n}\n.ov-group-sub {\n  font-size: 12.5px;\n  color: var(--ov-muted-2);\n  margin-top: 8px;\n}\n.ov-split {\n  margin-top: auto;\n  padding-top: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n.ov-split-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 5px;\n}\n.ov-split-name {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 12.5px;\n  color: #e6e1d6;\n  white-space: nowrap;\n}\n.ov-swatch {\n  width: 9px;\n  height: 9px;\n  border-radius: 2px;\n  display: block;\n  flex-shrink: 0;\n}\n.ov-split-value {\n  font-size: 12.5px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.ov-track-dark {\n  height: 7px;\n  background: #302b23;\n  border-radius: 20px;\n  overflow: hidden;\n}\n.ov-track-dark > span {\n  display: block;\n  height: 100%;\n  border-radius: 20px;\n}\n.ov-group-divider {\n  width: 1px;\n  background: #302b23;\n  flex-shrink: 0;\n}\n.ov-group-right {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n.ov-kpi-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  margin-bottom: 18px;\n}\n.ov-kpi {\n  padding: 0 18px;\n  border-left: 1px solid #302b23;\n}\n.ov-kpi:first-child {\n  border-left-color: transparent;\n}\n.ov-kpi-label {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #8a8272;\n  white-space: nowrap;\n  margin-bottom: 6px;\n}\n.ov-kpi-value {\n  display: flex;\n  align-items: baseline;\n  gap: 7px;\n}\n.ov-kpi-value .ov-figure {\n  font-size: 30px;\n  line-height: 1;\n}\n.ov-kpi-delta {\n  font-size: 11.5px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.ov-kpi-sub {\n  font-size: 11.5px;\n  color: #8a8272;\n  margin-top: 4px;\n  white-space: nowrap;\n}\n.ov-chart-head {\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n  margin-bottom: 8px;\n  font-size: 12.5px;\n  font-weight: 600;\n}\n.ov-legend {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11.5px;\n  font-weight: 400;\n  color: var(--ov-muted-2);\n  white-space: nowrap;\n}\n.ov-legend i {\n  width: 14px;\n  height: 2px;\n  display: block;\n}\n.ov-chart {\n  height: 132px;\n}\n.ov-chart svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  overflow: visible;\n}\n.ov-chart-axis {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 7px;\n  border-top: 1px solid #2b261e;\n  margin-top: 7px;\n}\n.ov-chart-axis span {\n  font-size: 10.5px;\n  color: #8a8272;\n  white-space: nowrap;\n}\n\n/* ---------- sections 2 & 3: per business ---------- */\n.ov-businesses {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n.ov-biz {\n  background: var(--ov-card);\n  border: 1px solid var(--ov-line);\n  border-radius: 14px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.ov-biz-head {\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--ov-line-soft);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.ov-biz-accent {\n  width: 4px;\n  height: 38px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n.ov-biz-logo {\n  height: 40px;\n  width: auto;\n  max-width: 110px;\n  object-fit: contain;\n  flex-shrink: 0;\n  display: block;\n}\n\n/* Stands in for the logo for a business with no artwork — same footprint\n   as .ov-biz-logo so the card header keeps its rhythm. The colour is the\n   business's assigned accent, set inline. */\n.ov-biz-mark {\n  height: 40px;\n  min-width: 40px;\n  padding: 0 9px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border: 1px solid currentColor;\n  border-radius: 7px;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n.ov-biz-title {\n  flex-grow: 1;\n  min-width: 0;\n}\n.ov-biz-name {\n  font-size: 21px;\n  line-height: 1.1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ov-biz-meta {\n  font-size: 12px;\n  color: var(--ov-muted);\n  margin-top: 2px;\n  white-space: nowrap;\n}\n.ov-chip {\n  font-size: 11.5px;\n  font-weight: 600;\n  padding: 4px 9px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n.ov-chip-ok {\n  color: var(--ov-up);\n  background: #eaf1e9;\n}\n.ov-chip-warn {\n  color: var(--ov-warn);\n  background: #f9f1de;\n}\n.ov-link {\n  background: none;\n  border: none;\n  padding: 0;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--ov-gold);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.ov-biz-body {\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n.ov-biz-kpis {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n}\n.ov-biz-kpi {\n  padding: 0 12px;\n  border-left: 1px solid var(--ov-line);\n}\n.ov-biz-kpi:first-child {\n  border-left-color: transparent;\n}\n.ov-biz-kpi .ov-kpi-label {\n  color: var(--ov-muted);\n  font-size: 10px;\n  letter-spacing: 0.07em;\n  margin-bottom: 5px;\n}\n.ov-biz-kpi .ov-figure {\n  font-size: 25px;\n  line-height: 1;\n  color: var(--ov-ink);\n}\n.ov-biz-kpi .ov-kpi-delta {\n  font-size: 11px;\n}\n.ov-up {\n  color: var(--ov-up);\n}\n.ov-down {\n  color: var(--ov-down);\n}\n\n.ov-panel {\n  background: #fbf9f5;\n  border: 1px solid #eee9df;\n  border-radius: 10px;\n  padding: 12px 14px;\n}\n.ov-panel-head,\n.ov-block-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 9px;\n}\n.ov-panel-head b,\n.ov-block-head b {\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.ov-panel-head span,\n.ov-block-head span {\n  font-size: 11.5px;\n  color: var(--ov-muted);\n  white-space: nowrap;\n}\n.ov-stack {\n  display: flex;\n  gap: 3px;\n  margin-bottom: 8px;\n}\n.ov-stack > i {\n  height: 8px;\n  border-radius: 3px;\n  display: block;\n}\n.ov-stack-legend {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n.ov-stack-legend span {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11.5px;\n  color: #6f6a60;\n  white-space: nowrap;\n}\n.ov-stack-legend b {\n  font-weight: 600;\n  color: var(--ov-ink);\n  font-variant-numeric: tabular-nums;\n}\n.ov-swatch-sm {\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  display: block;\n  flex-shrink: 0;\n}\n\n.ov-sellers {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.ov-donut {\n  width: 74px;\n  height: 74px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ov-donut-hole {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: #fff;\n}\n.ov-seller-list {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.ov-seller {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.ov-seller-name {\n  font-size: 12px;\n  color: var(--ov-body);\n  flex-grow: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ov-seller-share {\n  font-size: 11px;\n  color: var(--ov-muted-2);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.ov-seller-value {\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  width: 52px;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.ov-money {\n  display: flex;\n  gap: 8px;\n  padding-top: 13px;\n  border-top: 1px solid var(--ov-line-soft);\n}\n.ov-money-cell {\n  flex-grow: 1;\n  border-radius: 9px;\n  padding: 9px 12px;\n  background: var(--ov-canvas);\n}\n.ov-money-cell.is-accent {\n  background: var(--rf-brand-tint);\n}\n.ov-money-cell.is-accent-teal {\n  background: var(--rf-accent-tint);\n}\n.ov-money-label {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--ov-muted);\n  white-space: nowrap;\n  margin-bottom: 4px;\n}\n.ov-money-value {\n  font-size: 16px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.ov-money-value.is-soft {\n  color: #6f6a60;\n}\n\n/* ---------- section 4: staff & products ---------- */\n/* Deliberately not a 1:1 grid: the business cards above are one column\n   per business, and two equal cards here would read as belonging to them.\n   Staff carries the level × business matrix, so it takes the wide column;\n   Products sits narrower beside it. */\n.ov-dir {\n  display: grid;\n  grid-template-columns: minmax(0, 1.7fr) minmax(0, 1fr);\n  gap: 16px;\n  align-items: start;\n}\n.ov-dir-card {\n  background: var(--ov-card);\n  border: 1px solid var(--ov-line);\n  border-radius: 14px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.ov-dir-head {\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--ov-line-soft);\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n}\n.ov-dir-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n.ov-dir-figures {\n  display: flex;\n  align-items: flex-end;\n  gap: 28px;\n}\n.ov-dir-head .ov-kpi-label {\n  color: var(--ov-muted);\n  font-size: 10px;\n  letter-spacing: 0.07em;\n  margin-bottom: 5px;\n}\n.ov-dir-head .ov-figure {\n  font-size: 34px;\n  line-height: 1;\n  color: var(--ov-ink);\n}\n.ov-dir-head .ov-kpi-sub {\n  color: var(--ov-muted);\n  margin-top: 0;\n}\n.ov-dir-body {\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* level × business matrix */\n.ov-matrix {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12.5px;\n}\n.ov-matrix th {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--ov-muted);\n  text-align: right;\n  padding: 0 0 7px 10px;\n  border-bottom: 1px solid var(--ov-line);\n  white-space: nowrap;\n}\n.ov-matrix td {\n  padding: 8px 0 8px 10px;\n  border-bottom: 1px solid var(--ov-line-soft);\n  text-align: right;\n  color: var(--ov-body);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.ov-matrix th:first-child,\n.ov-matrix td:first-child {\n  text-align: left;\n  padding-left: 0;\n}\n.ov-matrix td:first-child {\n  color: var(--ov-ink);\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ov-matrix-name {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.ov-matrix td.is-zero {\n  color: var(--ov-muted-2);\n}\n.ov-matrix td.is-total,\n.ov-matrix tfoot td {\n  font-weight: 600;\n  color: var(--ov-ink);\n}\n.ov-matrix tfoot td {\n  border-bottom: none;\n  padding-top: 9px;\n  padding-bottom: 0;\n}\n\n/* products per business */\n.ov-dir-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 13px;\n}\n.ov-dir .ov-split-name,\n.ov-dir .ov-split-value {\n  color: var(--ov-ink);\n}\n.ov-track {\n  height: 7px;\n  background: var(--ov-line-soft);\n  border-radius: 20px;\n  overflow: hidden;\n}\n.ov-track > span {\n  display: block;\n  height: 100%;\n  border-radius: 20px;\n}\n.ov-dir-sub {\n  font-size: 11.5px;\n  color: var(--ov-muted);\n  margin-top: 5px;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---------- loading skeleton / glare ---------- */\n/* While `.is-loading` is on the page root, every `.ov-skel` block hides its\n   content and shows a tinted placeholder with a sweeping glare; the three\n   section cards get a softer full-card sweep on top. */\n.ov-group,\n.ov-biz,\n.ov-dir-card {\n  position: relative;\n}\n.is-loading .ov-group,\n.is-loading .ov-biz {\n  overflow: hidden;\n}\n.is-loading .ov-skel {\n  position: relative;\n  --skel-inset: 0;\n  --skel-tint: #f1eee7;\n  --skel-glare: rgba(255, 255, 255, 0.75);\n}\n.is-loading .ov-group .ov-skel {\n  --skel-tint: #26221c;\n  --skel-glare: rgba(255, 255, 255, 0.09);\n}\n.is-loading .ov-skel > * {\n  visibility: hidden;\n}\n.is-loading .ov-skel::before,\n.is-loading .ov-skel::after {\n  content: \"\";\n  position: absolute;\n  inset: var(--skel-inset);\n  border-radius: 10px;\n  pointer-events: none;\n}\n.is-loading .ov-skel::before {\n  background: var(--skel-tint);\n}\n.is-loading .ov-skel::after {\n  overflow: hidden;\n  background: linear-gradient(\n    100deg,\n    transparent 35%,\n    var(--skel-glare) 50%,\n    transparent 65%\n  );\n  background-size: 250% 100%;\n  animation: ov-glare 1.5s ease-in-out infinite;\n}\n/* full-card sweep over each section card */\n.is-loading .ov-group::after,\n.is-loading .ov-biz::after,\n.ov-dir-card.is-loading::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background: linear-gradient(\n    100deg,\n    transparent 40%,\n    rgba(255, 255, 255, 0.5) 50%,\n    transparent 60%\n  );\n  background-size: 300% 100%;\n  animation: ov-glare 2.2s ease-in-out infinite;\n  animation-delay: 0.3s;\n}\n.is-loading .ov-group::after {\n  background-image: linear-gradient(\n    100deg,\n    transparent 40%,\n    rgba(255, 255, 255, 0.06) 50%,\n    transparent 60%\n  );\n}\n@keyframes ov-glare {\n  from {\n    background-position: 100% 0;\n  }\n  to {\n    background-position: -100% 0;\n  }\n}\n/* skeleton tweaks for specific blocks */\n.is-loading .ov-kpi,\n.is-loading .ov-biz-kpi {\n  --skel-inset: 0 8px;\n  border-left-color: transparent;\n}\n.is-loading .ov-kpi {\n  min-height: 64px;\n}\n.is-loading .ov-biz-kpi {\n  min-height: 52px;\n}\n.is-loading .ov-chip {\n  min-width: 84px;\n  min-height: 24px;\n  --skel-inset: 0;\n}\n.is-loading .ov-chip::before,\n.is-loading .ov-chip::after {\n  border-radius: 20px;\n}\n.is-loading .ov-group-hero {\n  min-height: 120px;\n}\n.is-loading .ov-split::before,\n.is-loading .ov-split::after {\n  inset: 18px 0 0 0;\n}\n.is-loading .ov-chart-block {\n  min-height: 190px;\n}\n.is-loading .ov-money-cell::before,\n.is-loading .ov-money-cell::after {\n  border-radius: 9px;\n}\n.is-loading .ov-sellers-block {\n  min-height: 100px;\n}\n/* People & catalogue cards — each carries its own .is-loading */\n.ov-dir-card.is-loading .ov-kpi-value {\n  min-height: 34px;\n  min-width: 96px;\n}\n.ov-dir-card.is-loading .ov-dir-skel-bar::before,\n.ov-dir-card.is-loading .ov-dir-skel-bar::after {\n  border-radius: 6px;\n}\n.ov-dir-card.is-loading .ov-dir-skel-bar {\n  min-height: 10px;\n}\n.ov-dir-card.is-loading .ov-stack-legend::before,\n.ov-dir-card.is-loading .ov-stack-legend::after,\n.ov-dir-card.is-loading .ov-dir-row::before,\n.ov-dir-card.is-loading .ov-dir-row::after {\n  border-radius: 8px;\n}\n@media (prefers-reduced-motion: reduce) {\n  .is-loading .ov-skel::after,\n  .is-loading .ov-group::after,\n  .is-loading .ov-biz::after,\n  .ov-dir-card.is-loading::after {\n    animation: none;\n  }\n}\n\n/* ---------- responsive: tablet ---------- */\n@media (max-width: 1200px) {\n  .ov-businesses,\n  .ov-dir {\n    grid-template-columns: 1fr;\n  }\n  .ov-group {\n    flex-wrap: wrap;\n  }\n  .ov-group-left {\n    width: 100%;\n  }\n  .ov-group-divider {\n    display: none;\n  }\n  .ov-cal {\n    width: 380px;\n  }\n  .ov-cal-months {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
